import React, { FC } from 'react';
import { Paragraph } from '../../../../shared/components';
import { useTranslation } from 'react-i18next';
import { useUser } from '../../../../shared/hooks';
import TrajectoryCurriculumGoals from './TrajectoryCurriculumGoals';
import { Theme, styled } from '@material-ui/core';
import { useAppSelector } from 'src/modules/shared/hooks/useAppDispatch';

const StyledParagraph = styled(Paragraph)<Theme>(({ theme }) => ({
  marginBottom: theme.spacing(4),
}));

const Wrapper = styled('div')<Theme>(({ theme }) => ({
  padding: theme.spacing(2),
}));

const CurriculumGoalsSidebarContent: FC = () => {
  const { t } = useTranslation();
  const { isAuthor } = useUser();
  const currentBookId = useAppSelector((state) => state.trajectories.currentBookId);

  return (
    <Wrapper>
      <StyledParagraph>
        {isAuthor
          ? t('trajectory.sidebar.curriculumGoals.introAuthor')
          : t('trajectory.sidebar.curriculumGoals.introTeacherStudent')}
      </StyledParagraph>
      <TrajectoryCurriculumGoals type="ko" bookId={currentBookId!} />
      <TrajectoryCurriculumGoals type="go" bookId={currentBookId!} />
    </Wrapper>
  );
};

export default CurriculumGoalsSidebarContent;
